import { Component } from '@angular/core'
import { AuthService } from '@engineering11/auth-web'
@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  constructor(private authService: AuthService) {}
}
